import React from 'react';
import {Link} from "react-router-dom";
import imageOnError from '../helpers/imgOnError.js';

interface DomainReferenceProps {
    domain: string;
    openProtocol?: string;
    title?: string;
}

export default function DomainReference({domain, openProtocol, title}: DomainReferenceProps) {

	// if title not defined ... use default title
	const realTitle = 
		(title && title.length > 0) ? 
			title :
			title=`${domain} technology stack and statistics`;


	return (
		<>
			<img 
				src={`https://www.google.com/s2/favicons?domain=${domain}`} 
				onError={imageOnError}       
				width="16"
				height="16"
			/>
			<Link 
				className="link-hover word-break" 
				title={realTitle} 
				to={`/website/${domain}`}
			>
				{' '}{domain}{' '}
			</Link>
			{/* No <Link>! this is external reference 
			<a
				target="_blank" 
				rel="noopener nofollow noreferrer" 
				href={`${openProtocol}://${domain}/`}
			>
				<span className="icon text-right fa fa-external_link"></span>
			</a>
			*/}
		</>
	)
}